import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "./styles/app-theme.css"; // global "Deep Sea Instrument" theme (visual only)

import router from "./router";
import store from "./store";

require("@/store/subscriber");


require("./mixin.js");
// Use offline-first axios configuration instead of regular axios
require("./axios-offline.js");
require('./filters.js')

// Import offline detection and debugging
import { setupOfflineMode } from "./offline-detector";
import { debugOfflineMode } from "./utils/offline-debug";

Vue.config.productionTip = false;

// Make debug utility globally available in development
if (process.env.NODE_ENV === 'development' || window.electron) {
  window.debugOfflineMode = debugOfflineMode;
}

import VueDocPreview from "vue-doc-preview";
Vue.component("VueDocPreview", VueDocPreview);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);


// Initialize offline mode if running in Electron
setupOfflineMode(store);

store.dispatch("auth/attempt", localStorage.getItem("token")).then(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
});
